export default "__VITE_ASSET__DIQN2z$s__"